import React, { createContext, useState } from "react";

import { Supplier } from "../models/supplier";
import { UserStatus } from "../util/enums";

interface SupplierContextProps {
  supplier?: Supplier;
  setSupplier: React.Dispatch<React.SetStateAction<Supplier>>;
  handleUpdateSupplier: (attribute: string, value: any) => void;
  handleUpdateLocationSupplier: (attribute: string, value: any) => void;
}

const SupplierContext = createContext<SupplierContextProps>({} as SupplierContextProps);

interface SupplierProviderProps {
  children: React.ReactChild;
}

const SupplierProvider = ({ children }: SupplierProviderProps) => {
  const [supplier, setSupplier] = useState<Supplier>({ status: UserStatus.ACTIVE } as Supplier);

  const handleUpdateSupplier = (attribute: string, value: any) => {
    if (attribute && attribute !== "all") {
      if (!["string", "number", "boolean", "object"].includes(typeof value))
        setSupplier((state: Supplier) => ({
          ...state,
          [attribute]: [...value],
        }));
      else setSupplier((state: Supplier) => ({ ...state, [attribute]: value }));
    } else {
      setSupplier({ ...value });
    }
  };

  const handleUpdateLocationSupplier = (attribute: string, value: any) => {
    if (attribute && attribute !== "all") {
      if (!["string", "number", "boolean", "object"].includes(typeof value))
        setSupplier((prevSupplier: Supplier) => ({
          ...prevSupplier,
          location: { ...prevSupplier.location, [attribute]: [...value] },
        }));
      else
        setSupplier((prevSupplier: Supplier) => ({
          ...prevSupplier,
          location: { ...prevSupplier.location, [attribute]: value },
        }));
    } else {
      setSupplier((prevSupplier: Supplier) => ({
        ...prevSupplier,
        location: value,
      }));
    }
  };

  return (
    <SupplierContext.Provider
      value={{
        supplier,
        setSupplier,
        handleUpdateSupplier,
        handleUpdateLocationSupplier,
      }}
    >
      {children}
    </SupplierContext.Provider>
  );
};

export { SupplierContext, SupplierProvider };
